import { motion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { ThumbsUp, ThumbsDown } from "lucide-react";

type FeedbackButtonsProps = {
  onFeedback: (isPositive: boolean) => void;
};

const FeedbackButtons = ({ onFeedback }: FeedbackButtonsProps) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex justify-center gap-4"
    >
      <Button
        onClick={() => onFeedback(true)}
        className="bg-green-500 hover:bg-green-600 gap-2"
      >
        <ThumbsUp className="w-4 h-4" />
        Yes
      </Button>
      <Button
        onClick={() => onFeedback(false)}
        className="bg-red-500 hover:bg-red-600 gap-2"
      >
        <ThumbsDown className="w-4 h-4" />
        No
      </Button>
    </motion.div>
  );
};

export default FeedbackButtons;